export default __webpack_public_path__ + "assets/img/img-trust-arc.68d957cd91dda1db2b2c68b11d55b4ad.svg";